import { axios } from 'utils/axios';

const submitFeedback = (data) => {
  return axios.post('/feedback/', data);
};

export { submitFeedback };
